// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_wh","postedByDate":"e_xh","mobileView":"e_yh"};